<div class="search-bar-container">
  <input
    #searchInput
    type="text"
    [(ngModel)]="searchQuery"
    (input)="onSearchChange($event)"
    [attr.placeholder]="t.PLACEHOLDER_SEARCH_APPLICATIONS"
    class="search-input"
    autofocus
  />
  <button class="close-btn" (click)="clearAndClose()" [attr.title]="t.TOOLTIP_CLOSE_SEARCH">
    <i class="bi bi-x-circle"></i>
  </button>
</div>
